<template>
  <div class="container">
    <h3>Novedades</h3>
    <div class="d-flex justify-content-center my-lg-5">
      <div class="row">
        <div class="col-12 col-sm-4">
          <iframe
            src="https://docs.google.com/presentation/d/e/2PACX-1vQVxSsoluRl6s6mXY4pW-ZWYN1fwz6Eyp10HwT7nA4Qt2pdCsQSZRXLPPLaV_UwMRSi1Ck-LRjkMFRm/embed?start=true&loop=false&delayms=3000&rm=minimal"
            width="400"
            height="250"
            frameborder="0"
            class="iframe-google"
            allowfullscreen="true"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
          ></iframe>
        </div>
        <div class="col-12 col-sm-4">
          <iframe
            src="https://docs.google.com/presentation/d/e/2PACX-1vTftjqEeMA2MypV1tyQGkuKWM9LvN8kps_ZOs4pRDE91_0yPI8V7aF8sqsFmx7md-902GL_dtX-7jbk/embed?start=true&loop=false&delayms=3000&rm=minimal"
            frameborder="0"
            id="iframe"
            width="400"
            height="250"
            class="iframe-google"
            allowfullscreen="true"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
          ></iframe>
        </div>
        <div class="col-12 col-sm-4 mb-5">
          <iframe
            src="https://docs.google.com/presentation/d/e/2PACX-1vTVKRmRW2RccsapUdR2irMFtnj4_vgYnlTHU0PO9Bx1B1Z-KyJTXMVbky15_-LPvFlQGyR_7VyZipCi/embed?start=true&loop=false&delayms=3000&rm=minimal"
            frameborder="0"
            width="400"
            class="iframe-google"
            height="250"
            id="iframe"
            allowfullscreen="true"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GoogleSliderComponent",
  props: {
    titulo: String,
  },
  data() {
    return {
      hash: "GSC",
      title: null,
    };
  },
};
</script>
<style>
@media screen and (max-width: 767px) {
  .iframe-google {
    width: min-content;
  }
}
</style>
